export const borderRadiusVariants = {
  'border-radius': {
    xs: 'rounded-xs',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    '2xl': 'rounded-2xl',
    '3xl': 'rounded-3xl',
    none: 'rounded-none',
    full: 'rounded-full',
  },
  'border-radius-sm': {
    xs: 'sm:rounded-sm',
    sm: 'sm:rounded-md',
    md: 'sm:rounded-lg',
    lg: 'sm:rounded-xl',
    xl: 'sm:rounded-2xl',
    '2xl': 'sm:rounded-3xl',
    none: 'sm:rounded-none',
    full: 'sm:rounded-full',
  },
  'border-radius-md': {
    xs: 'md:rounded-xs',
    sm: 'md:rounded-sm',
    md: 'md:rounded-md',
    lg: 'md:rounded-lg',
    xl: 'md:rounded-xl',
    '2xl': 'md:rounded-2xl',
    '3xl': 'md:rounded-3xl',
    none: 'md:rounded-none',
    full: 'md:rounded-full',
  },
  'border-radius-lg': {
    xs: 'lg:rounded-xs',
    sm: 'lg:rounded-sm',
    md: 'lg:rounded-md',
    lg: 'lg:rounded-lg',
    xl: 'lg:rounded-xl',
    '2xl': 'lg:rounded-2xl',
    '3xl': 'lg:rounded-3xl',
    none: 'lg:rounded-none',
    full: 'lg:rounded-full',
  },
  'border-radius-xl': {
    xs: 'xl:rounded-xs',
    sm: 'xl:rounded-sm',
    md: 'xl:rounded-md',
    lg: 'xl:rounded-lg',
    xl: 'xl:rounded-xl',
    '2xl': 'xl:rounded-2xl',
    '3xl': 'xl:rounded-3xl',
    none: 'xl:rounded-none',
    full: 'xl:rounded-full',
  },
  'border-radius-t': {
    xs: 'rounded-t-xs',
    sm: 'rounded-t-sm',
    md: 'rounded-t-md',
    lg: 'rounded-t-lg',
    xl: 'rounded-t-xl',
    '2xl': 'rounded-t-2xl',
    '3xl': 'rounded-t-3xl',
    none: 'rounded-t-none',
    full: 'rounded-t-full',
  },
  'border-radius-t-sm': {
    xs: 'sm:rounded-t-xs',
    sm: 'sm:rounded-t-sm',
    md: 'sm:rounded-t-md',
    lg: 'sm:rounded-t-lg',
    xl: 'sm:rounded-t-xl',
    '2xl': 'sm:rounded-t-2xl',
    '3xl': 'sm:rounded-t-3xl',
    none: 'sm:rounded-t-none',
    full: 'sm:rounded-t-full',
  },
  'border-radius-t-md': {
    xs: 'md:rounded-t-xs',
    sm: 'md:rounded-t-sm',
    md: 'md:rounded-t-md',
    lg: 'md:rounded-t-lg',
    xl: 'md:rounded-t-xl',
    '2xl': 'md:rounded-t-2xl',
    '3xl': 'md:rounded-t-3xl',
    none: 'md:rounded-t-none',
    full: 'md:rounded-t-full',
  },
  'border-radius-t-lg': {
    xs: 'lg:rounded-t-xs',
    sm: 'lg:rounded-t-sm',
    md: 'lg:rounded-t-md',
    lg: 'lg:rounded-t-lg',
    xl: 'lg:rounded-t-xl',
    '2xl': 'lg:rounded-t-2xl',
    '3xl': 'lg:rounded-t-3xl',
    none: 'lg:rounded-t-none',
    full: 'lg:rounded-t-full',
  },
  'border-radius-t-xl': {
    xs: 'xl:rounded-t-xs',
    sm: 'xl:rounded-t-sm',
    md: 'xl:rounded-t-md',
    lg: 'xl:rounded-t-lg',
    xl: 'xl:rounded-t-xl',
    '2xl': 'xl:rounded-t-2xl',
    '3xl': 'xl:rounded-t-3xl',
    none: 'xl:rounded-t-none',
    full: 'xl:rounded-t-full',
  },
  'border-radius-r': {
    xs: 'rounded-r-xs',
    sm: 'rounded-r-sm',
    md: 'rounded-r-md',
    lg: 'rounded-r-lg',
    xl: 'rounded-r-xl',
    '2xl': 'rounded-r-2xl',
    '3xl': 'rounded-r-3xl',
    none: 'rounded-r-none',
    full: 'rounded-r-full',
  },
  'border-radius-r-sm': {
    xs: 'sm:rounded-r-xs',
    sm: 'sm:rounded-r-sm',
    md: 'sm:rounded-r-md',
    lg: 'sm:rounded-r-lg',
    xl: 'sm:rounded-r-xl',
    '2xl': 'sm:rounded-r-2xl',
    '3xl': 'sm:rounded-r-3xl',
    none: 'sm:rounded-r-none',
    full: 'sm:rounded-r-full',
  },
  'border-radius-r-md': {
    xs: 'md:rounded-r-xs',
    sm: 'md:rounded-r-sm',
    md: 'md:rounded-r-md',
    lg: 'md:rounded-r-lg',
    xl: 'md:rounded-r-xl',
    '2xl': 'md:rounded-r-2xl',
    '3xl': 'md:rounded-r-3xl',
    none: 'md:rounded-r-none',
    full: 'md:rounded-r-full',
  },
  'border-radius-r-lg': {
    xs: 'lg:rounded-r-xs',
    sm: 'lg:rounded-r-sm',
    md: 'lg:rounded-r-md',
    lg: 'lg:rounded-r-lg',
    xl: 'lg:rounded-r-xl',
    '2xl': 'lg:rounded-r-2xl',
    '3xl': 'lg:rounded-r-3xl',
    none: 'lg:rounded-r-none',
    full: 'lg:rounded-r-full',
  },
  'border-radius-r-xl': {
    xs: 'xl:rounded-r-xs',
    sm: 'xl:rounded-r-sm',
    md: 'xl:rounded-r-md',
    lg: 'xl:rounded-r-lg',
    xl: 'xl:rounded-r-xl',
    '2xl': 'xl:rounded-r-2xl',
    '3xl': 'xl:rounded-r-3xl',
    none: 'xl:rounded-r-none',
    full: 'xl:rounded-r-full',
  },
  'border-radius-b': {
    xs: 'rounded-b-xs',
    sm: 'rounded-b-sm',
    md: 'rounded-b-md',
    lg: 'rounded-b-lg',
    xl: 'rounded-b-xl',
    '2xl': 'rounded-b-2xl',
    '3xl': 'rounded-b-3xl',
    none: 'rounded-b-none',
    full: 'rounded-b-full',
  },
  'border-radius-b-sm': {
    xs: 'sm:rounded-b-xs',
    sm: 'sm:rounded-b-sm',
    md: 'sm:rounded-b-md',
    lg: 'sm:rounded-b-lg',
    xl: 'sm:rounded-b-xl',
    '2xl': 'sm:rounded-b-2xl',
    '3xl': 'sm:rounded-b-3xl',
    none: 'sm:rounded-b-none',
    full: 'sm:rounded-b-full',
  },
  'border-radius-b-md': {
    xs: 'md:rounded-b-xs',
    sm: 'md:rounded-b-sm',
    md: 'md:rounded-b-md',
    lg: 'md:rounded-b-lg',
    xl: 'md:rounded-b-xl',
    '2xl': 'md:rounded-b-2xl',
    '3xl': 'md:rounded-b-3xl',
    none: 'md:rounded-b-none',
    full: 'md:rounded-b-full',
  },
  'border-radius-b-lg': {
    xs: 'lg:rounded-b-xs',
    sm: 'lg:rounded-b-sm',
    md: 'lg:rounded-b-md',
    lg: 'lg:rounded-b-lg',
    xl: 'lg:rounded-b-xl',
    '2xl': 'lg:rounded-b-2xl',
    '3xl': 'lg:rounded-b-3xl',
    none: 'lg:rounded-b-none',
    full: 'lg:rounded-b-full',
  },
  'border-radius-b-xl': {
    xs: 'xl:rounded-b-xs',
    sm: 'xl:rounded-b-sm',
    md: 'xl:rounded-b-md',
    lg: 'xl:rounded-b-lg',
    xl: 'xl:rounded-b-xl',
    '2xl': 'xl:rounded-b-2xl',
    '3xl': 'xl:rounded-b-3xl',
    none: 'xl:rounded-b-none',
    full: 'xl:rounded-b-full',
  },
  'border-radius-l': {
    xs: 'rounded-l-xs',
    sm: 'rounded-l-sm',
    md: 'rounded-l-md',
    lg: 'rounded-l-lg',
    xl: 'rounded-l-xl',
    '2xl': 'rounded-l-2xl',
    '3xl': 'rounded-l-3xl',
    none: 'rounded-l-none',
    full: 'rounded-l-full',
  },
  'border-radius-l-sm': {
    xs: 'sm:rounded-l-xs',
    sm: 'sm:rounded-l-sm',
    md: 'sm:rounded-l-md',
    lg: 'sm:rounded-l-lg',
    xl: 'sm:rounded-l-xl',
    '2xl': 'sm:rounded-l-2xl',
    '3xl': 'sm:rounded-l-3xl',
    none: 'sm:rounded-l-none',
    full: 'sm:rounded-l-full',
  },
  'border-radius-l-md': {
    xs: 'md:rounded-l-xs',
    sm: 'md:rounded-l-sm',
    md: 'md:rounded-l-md',
    lg: 'md:rounded-l-lg',
    xl: 'md:rounded-l-xl',
    '2xl': 'md:rounded-l-2xl',
    '3xl': 'md:rounded-l-3xl',
    none: 'md:rounded-l-none',
    full: 'md:rounded-l-full',
  },
  'border-radius-l-lg': {
    xs: 'lg:rounded-l-xs',
    sm: 'lg:rounded-l-sm',
    md: 'lg:rounded-l-md',
    lg: 'lg:rounded-l-lg',
    xl: 'lg:rounded-l-xl',
    '2xl': 'lg:rounded-l-2xl',
    '3xl': 'lg:rounded-l-3xl',
    none: 'lg:rounded-l-none',
    full: 'lg:rounded-l-full',
  },
  'border-radius-l-xl': {
    xs: 'xl:rounded-l-xs',
    sm: 'xl:rounded-l-sm',
    md: 'xl:rounded-l-md',
    lg: 'xl:rounded-l-lg',
    xl: 'xl:rounded-l-xl',
    '2xl': 'xl:rounded-l-2xl',
    '3xl': 'xl:rounded-l-3xl',
    none: 'xl:rounded-l-none',
    full: 'xl:rounded-l-full',
  },
  'border-radius-tl': {
    xs: 'rounded-tl-xs',
    sm: 'rounded-tl-sm',
    md: 'rounded-tl-md',
    lg: 'rounded-tl-lg',
    xl: 'rounded-tl-xl',
    '2xl': 'rounded-tl-2xl',
    '3xl': 'rounded-tl-3xl',
    none: 'rounded-tl-none',
    full: 'rounded-tl-full',
  },
  'border-radius-tl-sm': {
    xs: 'sm:rounded-tl-xs',
    sm: 'sm:rounded-tl-sm',
    md: 'sm:rounded-tl-md',
    lg: 'sm:rounded-tl-lg',
    xl: 'sm:rounded-tl-xl',
    '2xl': 'sm:rounded-tl-2xl',
    '3xl': 'sm:rounded-tl-3xl',
    none: 'sm:rounded-tl-none',
    full: 'sm:rounded-tl-full',
  },
  'border-radius-tl-md': {
    xs: 'md:rounded-tl-xs',
    sm: 'md:rounded-tl-sm',
    md: 'md:rounded-tl-md',
    lg: 'md:rounded-tl-lg',
    xl: 'md:rounded-tl-xl',
    '2xl': 'md:rounded-tl-2xl',
    '3xl': 'md:rounded-tl-3xl',
    none: 'md:rounded-tl-none',
    full: 'md:rounded-tl-full',
  },
  'border-radius-tl-lg': {
    xs: 'lg:rounded-tl-xs',
    sm: 'lg:rounded-tl-sm',
    md: 'lg:rounded-tl-md',
    lg: 'lg:rounded-tl-lg',
    xl: 'lg:rounded-tl-xl',
    '2xl': 'lg:rounded-tl-2xl',
    '3xl': 'lg:rounded-tl-3xl',
    none: 'lg:rounded-tl-none',
    full: 'lg:rounded-tl-full',
  },
  'border-radius-tl-xl': {
    xs: 'xl:rounded-tl-xs',
    sm: 'xl:rounded-tl-sm',
    md: 'xl:rounded-tl-md',
    lg: 'xl:rounded-tl-lg',
    xl: 'xl:rounded-tl-xl',
    '2xl': 'xl:rounded-tl-2xl',
    '3xl': 'xl:rounded-tl-3xl',
    none: 'xl:rounded-tl-none',
    full: 'xl:rounded-tl-full',
  },
  'border-radius-tr': {
    xs: 'rounded-tr-xs',
    sm: 'rounded-tr-sm',
    md: 'rounded-tr-md',
    lg: 'rounded-tr-lg',
    xl: 'rounded-tr-xl',
    '2xl': 'rounded-tr-2xl',
    '3xl': 'rounded-tr-3xl',
    none: 'rounded-tr-none',
    full: 'rounded-tr-full',
  },
  'border-radius-tr-sm': {
    xs: 'sm:rounded-tr-xs',
    sm: 'sm:rounded-tr-sm',
    md: 'sm:rounded-tr-md',
    lg: 'sm:rounded-tr-lg',
    xl: 'sm:rounded-tr-xl',
    '2xl': 'sm:rounded-tr-2xl',
    '3xl': 'sm:rounded-tr-3xl',
    none: 'sm:rounded-tr-none',
    full: 'sm:rounded-tr-full',
  },
  'border-radius-tr-md': {
    xs: 'md:rounded-tr-xs',
    sm: 'md:rounded-tr-sm',
    md: 'md:rounded-tr-md',
    lg: 'md:rounded-tr-lg',
    xl: 'md:rounded-tr-xl',
    '2xl': 'md:rounded-tr-2xl',
    '3xl': 'md:rounded-tr-3xl',
    none: 'md:rounded-tr-none',
    full: 'md:rounded-tr-full',
  },
  'border-radius-tr-lg': {
    xs: 'lg:rounded-tr-xs',
    sm: 'lg:rounded-tr-sm',
    md: 'lg:rounded-tr-md',
    lg: 'lg:rounded-tr-lg',
    xl: 'lg:rounded-tr-xl',
    '2xl': 'lg:rounded-tr-2xl',
    '3xl': 'lg:rounded-tr-3xl',
    none: 'lg:rounded-tr-none',
    full: 'lg:rounded-tr-full',
  },
  'border-radius-tr-xl': {
    xs: 'xl:rounded-tr-xs',
    sm: 'xl:rounded-tr-sm',
    md: 'xl:rounded-tr-md',
    lg: 'xl:rounded-tr-lg',
    xl: 'xl:rounded-tr-xl',
    '2xl': 'xl:rounded-tr-2xl',
    '3xl': 'xl:rounded-tr-3xl',
    none: 'xl:rounded-tr-none',
    full: 'xl:rounded-tr-full',
  },
  'border-radius-bl': {
    xs: 'rounded-bl-xs',
    sm: 'rounded-bl-sm',
    md: 'rounded-bl-md',
    lg: 'rounded-bl-lg',
    xl: 'rounded-bl-xl',
    '2xl': 'rounded-bl-2xl',
    '3xl': 'rounded-bl-3xl',
    none: 'rounded-bl-none',
    full: 'rounded-bl-full',
  },
  'border-radius-bl-sm': {
    xs: 'sm:rounded-bl-xs',
    sm: 'sm:rounded-bl-sm',
    md: 'sm:rounded-bl-md',
    lg: 'sm:rounded-bl-lg',
    xl: 'sm:rounded-bl-xl',
    '2xl': 'sm:rounded-bl-2xl',
    '3xl': 'sm:rounded-bl-3xl',
    none: 'sm:rounded-bl-none',
    full: 'sm:rounded-bl-full',
  },
  'border-radius-bl-md': {
    xs: 'md:rounded-bl-xs',
    sm: 'md:rounded-bl-sm',
    md: 'md:rounded-bl-md',
    lg: 'md:rounded-bl-lg',
    xl: 'md:rounded-bl-xl',
    '2xl': 'md:rounded-bl-2xl',
    '3xl': 'md:rounded-bl-3xl',
    none: 'md:rounded-bl-none',
    full: 'md:rounded-bl-full',
  },
  'border-radius-bl-lg': {
    xs: 'lg:rounded-bl-xs',
    sm: 'lg:rounded-bl-sm',
    md: 'lg:rounded-bl-md',
    lg: 'lg:rounded-bl-lg',
    xl: 'lg:rounded-bl-xl',
    '2xl': 'lg:rounded-bl-2xl',
    '3xl': 'lg:rounded-bl-3xl',
    none: 'lg:rounded-bl-none',
    full: 'lg:rounded-bl-full',
  },
  'border-radius-bl-xl': {
    xs: 'xl:rounded-bl-xs',
    sm: 'xl:rounded-bl-sm',
    md: 'xl:rounded-bl-md',
    lg: 'xl:rounded-bl-lg',
    xl: 'xl:rounded-bl-xl',
    '2xl': 'xl:rounded-bl-2xl',
    '3xl': 'xl:rounded-bl-3xl',
    none: 'xl:rounded-bl-none',
    full: 'xl:rounded-bl-full',
  },
  'border-radius-br': {
    xs: 'rounded-br-xs',
    sm: 'rounded-br-sm',
    md: 'rounded-br-md',
    lg: 'rounded-br-lg',
    xl: 'rounded-br-xl',
    '2xl': 'rounded-br-2xl',
    '3xl': 'rounded-br-3xl',
    none: 'rounded-br-none',
    full: 'rounded-br-full',
  },
  'border-radius-br-sm': {
    xs: 'sm:rounded-br-xs',
    sm: 'sm:rounded-br-sm',
    md: 'sm:rounded-br-md',
    lg: 'sm:rounded-br-lg',
    xl: 'sm:rounded-br-xl',
    '2xl': 'sm:rounded-br-2xl',
    '3xl': 'sm:rounded-br-3xl',
    none: 'sm:rounded-br-none',
    full: 'sm:rounded-br-full',
  },
  'border-radius-br-md': {
    xs: 'md:rounded-br-xs',
    sm: 'md:rounded-br-sm',
    md: 'md:rounded-br-md',
    lg: 'md:rounded-br-lg',
    xl: 'md:rounded-br-xl',
    '2xl': 'md:rounded-br-2xl',
    '3xl': 'md:rounded-br-3xl',
    none: 'md:rounded-br-none',
    full: 'md:rounded-br-full',
  },
  'border-radius-br-lg': {
    xs: 'lg:rounded-br-xs',
    sm: 'lg:rounded-br-sm',
    md: 'lg:rounded-br-md',
    lg: 'lg:rounded-br-lg',
    xl: 'lg:rounded-br-xl',
    '2xl': 'lg:rounded-br-2xl',
    '3xl': 'lg:rounded-br-3xl',
    none: 'lg:rounded-br-none',
    full: 'lg:rounded-br-full',
  },
  'border-radius-br-xl': {
    xs: 'xl:rounded-br-xs',
    sm: 'xl:rounded-br-sm',
    md: 'xl:rounded-br-md',
    lg: 'xl:rounded-br-lg',
    xl: 'xl:rounded-br-xl',
    '2xl': 'xl:rounded-br-2xl',
    '3xl': 'xl:rounded-br-3xl',
    none: 'xl:rounded-br-none',
    full: 'xl:rounded-br-full',
  },
}
